import * as React from 'react';
import { Pagination as RaPagination, PaginationActions as RaPaginationActions } from 'react-admin';

const PaginationActions = (props) => <RaPaginationActions {...props} color='secondary' />;

export const CustomPagination = (props) => (
    <RaPagination {...props} rowsPerPageOptions={[16, 25, 50, 100]} ActionsComponent={PaginationActions} />
);
